import { ReactElement } from 'react';

import { DatatableSkeleton } from '@components/Skeleton/DatatableSkeleton';
import { Divider, Skeleton, Stack } from '@mui/material';

export const HistoryActionsSkeleton = (): ReactElement => {
  return (
    <Stack gap={4}>
      <Skeleton variant="text" animation="wave" width={400} height={86} />

      <Stack direction="row" gap={2} alignItems="center">
        <Skeleton variant="text" animation="wave" width={60} height={30} />

        {Array.from({ length: 6 }, (_, i) => i).map((i) => (
          <Skeleton
            key={i}
            sx={{ borderRadius: '20px' }}
            variant="rounded"
            animation="wave"
            width={100}
            height={30}
          />
        ))}
        <Divider orientation="vertical" flexItem />
        <Skeleton variant="text" animation="wave" width={100} height={50} />
      </Stack>

      <Stack justifyContent="start">
        <DatatableSkeleton />
      </Stack>
      <Skeleton variant="rectangular" animation="wave" height={50} />
    </Stack>
  );
};
